<template>
	<v-container fluid tag="section">
		<v-form ref="form" v-model="valid" lazy-validation>
			<ti-card :icon="$icons.tracks">
				<template #title><span>{{ isEdit ? 'Edit' : 'New' }}</span> Track</template>
				<template #title-actions-shown>
					<v-btn color="success" elevation="2" fab small class="mr-4" @click="save">
						<v-icon>{{ $icons.save }}</v-icon>
					</v-btn>
				</template>
				<template #title-actions-hidden>
					<ti-confirm @confirm="destroy" message="Are you sure you want to delete this track?" button-text="Delete">
						<v-btn color="error" elevation="2" fab small class="mr-4">
							<v-icon>{{ $icons.delete }}</v-icon>
						</v-btn>
					</ti-confirm>
				</template>
				<ti-form-layout>
					<template>
						<!-- FORM FIELDS-->
					</template>
				</ti-form-layout>
			</ti-card>
		</v-form>
	</v-container>
</template>
<script>

import validationRules from "@/util/validation";
import _forEach from 'lodash/forEach'
import {sync} from "vuex-pathify";

export default {
	name: "TracksForm",
	props: ['id'],
	computed: {
		isEdit() {
			return this.$route.meta?.edit
		},
		track: sync('tracks/track')
	},
	data: () => ({
		valid: false,
	}),
	beforeMount() {
		this.init()
	},
	methods: {
		init() {
			if (this.isEdit) {
				this.$store.set('tracks/getTrack!', this.id)
			} else {
				this.track = {
					track_from: '',
					track_to: ''
				}
			}
		},
		getBrand() {
			this.$api.tracks.show(this.id)
				.then(response => {
					this.track = response.data
				})
				.catch(error => {
					console.log(error.response);
					this.$toast.add(error.response.message, 'error')
					// this.$toast.handleResponseErrors(this, error)
				})
		},
		save() {
			if (this.$refs.form.validate()) {
				if (this.isEdit) {
					this.$api.tracks.update(this.id, this.track)
						.then(response => {
							this.$toast.add('Track updated successfully', 'success')
							this.$route.meta.disableWarn = true;
							this.$router.push({name: 'Tracks'})
						})
						.catch(error => {
							console.log(error.response);
							this.$toast.add(error.response.statusText, 'error')
						})
				} else {
					this.$api.tracks.create(this.track)
						.then(response => {
							this.$toast.add('Track created successfully', 'success')
							this.$route.meta.disableWarn = true;
							this.$router.push({name: 'Tracks'})
						})
						.catch(error => {
							console.log(error.response);
							this.$toast.add(error.response.statusText, 'error')
						})
				}
			} else {
				this.$toast.add('Please fix validation errors', 'error')
			}
		},
		destroy() {
			this.$api.tracks.delete(this.id, this.track)
				.then(response => {
					this.$toast.add('Track deleted successfully', 'success')
					this.$route.meta.disableWarn = true;
					this.$router.push({name: 'Tracks'})
				})
				.catch(error => {
					console.log(error.response);
					this.$toast.add(error.response.statusText, 'error')
				})
		},
	}
}
</script>